module.exports = __webpack_public_path__ + "img/daniel-urresti.9b5b50a6.png";